import {useMutation, useQueryClient} from "@tanstack/react-query";
import {adminsListSuperUrl} from "../../constants/api/endpoints";
import {useAxios} from "../../hooks/axios/useAxios";

export const useMutateActiveAdmin = () => {
  const queryClient = useQueryClient();
  const axios = useAxios();

  async function patchAssign(data: {admin_id: string, is_active: boolean}) {
    return axios.patch(adminsListSuperUrl, data)
  }

  return useMutation({
    mutationKey: ['admins-list-super-patch'],
    mutationFn: patchAssign,
    onMutate: () => {
      document.body.className = 'body-loading';
    },
    onSuccess: () => queryClient.invalidateQueries({queryKey: ['admins-list-super']})
          .then(() => document.body.removeAttribute('class'))
  });
}